import React, { useMemo } from 'react';
import { motion } from 'framer-motion';

const HolidayLights = () => {
  const lights = useMemo(() => {
    return Array.from({ length: 20 }, (_, i) => ({
      id: i,
      x: (i * 5) + Math.random() * 5,
      y: 10 + Math.random() * 20,
      color: ['red', 'green', 'blue', 'yellow', 'purple', 'pink'][Math.floor(Math.random() * 6)],
      delay: i * 0.2
    }));
  }, []);

  const getColorClass = (color) => {
    const colors = {
      red: 'bg-red-400 shadow-red-400/50',
      green: 'bg-green-400 shadow-green-400/50',
      blue: 'bg-blue-400 shadow-blue-400/50',
      yellow: 'bg-yellow-400 shadow-yellow-400/50',
      purple: 'bg-purple-400 shadow-purple-400/50',
      pink: 'bg-pink-400 shadow-pink-400/50'
    };
    return colors[color] || colors.red;
  };

  return (
    <div className="absolute inset-0 pointer-events-none">
      {/* String wire */}
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-gray-600 to-transparent" 
           style={{ top: '15%' }} />
      
      {lights.map((light) => (
        <motion.div
          key={light.id}
          className={`absolute w-3 h-4 rounded-full ${getColorClass(light.color)} shadow-lg`}
          style={{
            left: `${light.x}%`,
            top: `${light.y}%`
          }}
          animate={{
            opacity: [0.3, 1, 0.3],
            scale: [0.8, 1.2, 0.8],
            boxShadow: [
              '0 0 5px currentColor',
              '0 0 20px currentColor',
              '0 0 5px currentColor'
            ]
          }}
          transition={{
            duration: 2,
            repeat: Infinity,
            delay: light.delay,
            ease: "easeInOut"
          }}
        />
      ))}
    </div>
  );
};

export default HolidayLights;